import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import Typography from '@material-ui/core/Typography';

import { closeValidationNotification } from '../../../store/notifications/actions';
import ErrorDialog from './ErrorDialog';

function Validation (props) {
    const { open, messages } = props.systemNotification;
    const subtitle = `Please correct the following error${messages.length > 1 ? 's' : ''}:`;
    return (
        <ErrorDialog
            title="Validation Error"
            subtitle={subtitle}
            handleClose={props.closeDialog}
            open={open}
            message={
                <ul>
                    {messages.map((message, i) => (
                        <li key={i}>
                            <Typography color="error" variant="subtitle2">
                                {R.is(Object, message) && message.message}
                                {R.is(String, message) && message}
                            </Typography>
                        </li>
                    ))}
                </ul>
            }
        />
    );
}

const mapStateToProps = state => ({
    systemNotification: state.notifications.validation
});

const mapDispatchToProps = dispatch => ({
    closeDialog: () => dispatch(closeValidationNotification())
});

export default connect(mapStateToProps, mapDispatchToProps)(Validation);
